import type { RepeatableField } from "./types";

export interface KnownVariable {
  variable: { name: string; type: string; title?: string };
}

export const inferFields = (
  tokenNames: string[],
  knownVariables: KnownVariable[],
): RepeatableField[] => {
  const byName = new Map<string, KnownVariable["variable"]>();
  for (const kv of knownVariables) {
    const v = kv?.variable;
    if (v?.name && !byName.has(v.name)) byName.set(v.name, v);
  }
  return tokenNames.map((name) => {
    const v = byName.get(name);
    return { key: name, name: v?.title || name, type: v?.type || "input" };
  });
};
